export default __webpack_public_path__ + "static/media/(64).c1bdc3f3.jpg";